import { useQuery } from "@tanstack/react-query";

import { getFeatureFlag, GetFeatureFlagByNameRequest } from "@/api";

export const useGetUserFeatureFlag = (reqArgs: GetFeatureFlagByNameRequest, enabled: boolean = true) => {
  const { data, isError, isPending } = useQuery({
    queryKey: ["feature-flag", reqArgs.name, reqArgs],
    queryFn: () => getFeatureFlag(reqArgs),
    enabled: !!reqArgs && enabled,
    select: ({ enabled }) => enabled,
  });

  return {
    featureFlag: data,
    getUserFeatureFlagError: isError,
    isGetUserFeatureFlagLoading: isPending,
  };
};
